export const SERVER_URL: string = process.env.VUE_APP_API_SERVER_URL
export const CLASSIC_API_URL: string = process.env.VUE_APP_CLASSIC_API_BASE_PATH
export const CLASSIC_API_URL_BASE: string = `${SERVER_URL}/${CLASSIC_API_URL}`
export const REPORT_URL_BASE: string = `${CLASSIC_API_URL_BASE}/reports`
export const CSV_REPORT_URL_BASE: string = `${CLASSIC_API_URL_BASE}/csv`

//For use when passing new/edit context as a route param
export const enum UserActionContexts {
  New = 'NEW',
  Edit = 'EDIT',
}
